import React from 'react';

import './style.less';

interface IProps {
    id?: string;
    children: React.ReactNode;
    containerStyle?: React.CSSProperties;
    className?: string;
    onClick?: () => void;
}

const Card = (props: IProps): React.ReactElement => {
    const { children, containerStyle, id, className, onClick } = props;

    const style = ["card-wrapper", className].join(' ');
    return (
        <div style={containerStyle} className={style} key={id} onClick={onClick}>
            {children}
        </div>
    )
}

Card.defaultProps = {
    containerStyle: {},
}

const cardMemoizedComponent = React.memo(Card);
export { cardMemoizedComponent as Card };
